'use strict';
import classNames from 'classnames';
import * as T from 'prop-types';
import React from 'react';

export function ModalHeaderView(props) {
  return (
    <div
      className={classNames("ModalHeader", props.className)}
    >
      {props.modalHeaderLabel}
    </div>
  );
}

ModalHeaderView.propTypes = {
  className: T.string,
  modalHeaderLabel: T.node,
};

ModalHeaderView.defaultProps = {
  modalHeaderLabel: "Header",
};



// WEBPACK FOOTER //
// ./src/js/components/modals/ModalHeader/ModalHeaderView.js